var App = (function () {
  'use strict';

  App.retreatTableFilters = function () {
    var $table = $('#retreat-datatable');
    if(!$table.length) {
      return;
    }

    var inputSearch = $('.js-datatable-search');
    var visibleRowsInfo = $('.js-visible-rows-count');
    var selectedRowsInfo = $('.js-selected-rows-count');

    var renderAmountColumn = function (data, type, full, meta) {
      if (type === 'display') {
        var amount = parseInt(data);

        return amount !== 0 ? '<span class="datatable__main-text">' + amount.toLocaleString() + '</span>' : '';
      }

      return data;
    };

    var renderBoolColumn = function (data, type, full, meta) {
      if (type === 'display') {
        if (data == 'Есть') {
          return '<i class="icon mdi mdi-check-circle datatable__icon datatable__icon-success"></i>';
        }
        return '<i class="icon mdi mdi-close-circle datatable__icon datatable__icon-danger"></i>';
      }

      return data;
    };

    var renderFullnameColumn = function (data, type, full, meta) {
      if (type === 'display') {
        var email = full.client.email;
        var result = '<a href="' + full.client.link + '" target="_blank" class="datatable__main-link">' + data + "</a>";
        if (isNotEmpty(email)) {
          result += '<span class="datatable__cell-detail-description"><i class="mdi mdi-email"></i> ' + email + '</span>';
        }
        if (isSmallScreen()) {
          result += renderContactsColumn(data, type, full, meta);
        }

        return result;
      }

      return data;
    };

    var renderContactsColumn = function (data, type, full, meta) {
      if (type === 'display') {
        var profileVk = full.client.profile_vk;
        var phone = full.client.phone;
        var result = '';

        if (isNotEmpty(profileVk)) {
          profileVk = profileVk.trim();
          var url = profileVk.includes('https://') ? profileVk : 'https://' + profileVk;
          result += '<span class="datatable__cell-detail-description"><i class="mdi mdi-vk"></i> ' +
            '<a href="' + url + '" target="_blank">' + profileVk + '</a></span>';
        }

        if (isNotEmpty(phone)) {
          result += '<span class="datatable__cell-detail-description"><i class="mdi mdi-phone"></i> ' + phone + '</span>';
        }

        return result;
      }

      return data;
    };

    var columnNamesForExport = [
      'status:name',
      'full_name:name',
      'profile_vk:name',
      'phone:name',
      'email:name',
      'discount:name',
      'paid:name',
      'remain:name',
      'has_access:name',
      'has_free_access:name',
      'payment_comment:name',
      'utm:name'
    ];

    var courseDatatable = $table.DataTable({
      dom:  "<'row be-datatable-body'<'col-sm-12'tr>>" +
            "<'row be-datatable-footer'<'col-sm-2'l><'col-sm-4'i><'col-sm-6'p>>",
      processing: false,
      ajax: {
        url: '/json/crm_handler/',
        type: 'POST',
        data: {
          method: "GetClientsDatatable",
          course_id: $table.data("course-id"),
        }
      },
      deferRender: true,
      columns: [
        {
          data: null,
          orderable: false,
          searchable: false,
          defaultContent: '',
          className: 'select-checkbox',
        },
        {
          data: "href",
          searchable: false,
          render: function (data, type, full, meta) {
            var num = meta.row + 1;
            return type === 'display' ?
              num + ' <a href="' + data + '" target="_blank"><i class="mdi mdi-open-in-new"></i></a>' :
              data;
          },
        },
        {
          "data": "deal_id",
          "searchable": false,
          "visible": false,
        },
        { "data": "status_name" },
        {
          "data": "client.name",
          "render": renderFullnameColumn,
          "searchable": false,
        },
        getContactsColumnSettings(),
        {
          "data": "client.name",
          "visible": false
        },
        {
          "data": "client.profile_vk",
          "visible": false
        },
        {
          "data": "client.phone",
          "visible": false
        },
        {
          "data": "client.email",
          "visible": false
        },
        getAmountColumnSettings('discount'),
        getAmountColumnSettings('paid_summ'),
        getAmountColumnSettings('remain_summ'),
        getBooleanColumnSettings('has_access'),
        {
          "data": "has_free_access",
          "width": "62px",
          "className": "text-center",
          "render": function (data, type, full, meta) {
            if (type === 'display') {
              if (data == 'Есть') {
                return '<i class="icon mdi mdi-check-circle datatable__icon datatable__icon-success"></i>';
              }
              return '';
            }

            return data;
          }
        },
        {
          "data": "payment_comment",
          "render": function (data, type, row, meta) {
            return type === 'display' && data.length > 15 ?
              '<span title="' + data + '"><em>' + data.substr(0, 14) +'...</em></span>' :
              data;
          }
        },
        {
          "data": "utm",
          "searchable": false,
          "visible": false,
        }
      ],
      select: {
        style: 'multi',
        selector: 'td:first-child'
      },
      buttons: [
        {
          extend: 'selectAll',
          name: 'selectAll',
          action: function () {
            this.rows( {search:'applied'} ).select();
          }
        },
        {
          extend: 'selectNone',
          name: 'selectNone'
        },
        {
          extend: 'excel',
          name: 'excel',
          text: '<span class="icon mdi mdi-file"></span>',
          exportOptions: {
            columns: columnNamesForExport,
            orthogonal: 'export',
            modifier: {
              page: 'all',
              selected: true,
            }
          }
        },
        {
          name: 'resetSearch',
          action: function ( e, dt, node, config ) {
            dt.search('').draw();
          }
        }
      ],
      language: {
        select: {
          rows: {
              _: "Выбрано %d строк",
              0: "Выберите строку",
              1: "Только 1 строка выбрана"
          }
        }
      },
      paging: true,
      pageLength: 100,
      lengthMenu: [ [10, 50, 100, 300, -1], [10, 50, 100, 300, "Все"] ],
      ordering: false,
      orderClasses: false,
      stripeClasses: [],
      orderCellsTop: true,
      initComplete: function () {
        var datatable = this;
        var tableHeader = $table.find('thead');
        var tableColumnNames = tableHeader.find('tr');

        tableColumnNames.clone(true).appendTo(tableHeader);
        tableColumnNames.clone(true).appendTo(tableHeader);

        tableColumnNames.hide(); //для выгрузки в Excel создана 1-я скрытая строка с именами столбцов

        var filterRow = $table.find('thead tr:eq(1)');
        var theads = filterRow.find('th');

        filterRow.removeClass('datatable__column-names');
        theads.each(function () {
          this.innerHTML = '';
        });

        initAmountFilters(theads);
        initSelectFilters(theads);
        addResetLink(theads);

        function initSelectFilters(theads) {
          var columnNamesWithSelectFilter = [
            'status:name',
            'has_access:name',
            'has_free_access:name'
          ];

          datatable.api().columns(columnNamesWithSelectFilter).every(function() {
              var column = this;
              var idx = column.index('visible');
              var thead = theads.get(idx);

              var select = $('<select class="datatable__filter-select"><option value="" selected></option></select>')
                .appendTo(thead)
                .on('change', function () {
                  var val = $.fn.dataTable.util.escapeRegex(
                    $(this).val()
                  );

                  column
                    .search( val ? '^'+val+'$' : '', true, false )
                    .draw();
                });

              column.data().unique().sort().each(function (d, j) {
                select.append('<option value="' + d + '">' + d + '</option>');
              });
          });
        }

        function initAmountFilters(theads) {
          var discountColumnIdx = datatable.api().column('discount:name').index('visible');
          var paidColumnIdx = datatable.api().column('paid:name').index('visible');
          var remainColumnIdx = datatable.api().column('remain:name').index('visible');

          theads.get(discountColumnIdx).innerHTML = getInputTagWithId("minDiscount");
          theads.get(paidColumnIdx).innerHTML = getInputTagWithId("minPaid");
          theads.get(remainColumnIdx).innerHTML = getInputTagWithId("minDebt");

          $('#minDiscount, #minPaid, #minDebt').keyup( function() {
            courseDatatable.draw();
          });

          function getInputTagWithId(id) {
            return '<input id="' + id + '" type="text" style="width: 77px;" class="datatable__filter-input" placeholder="Сумма &ge;" />';
          }
        }

        function addResetLink(theads) {
          var commentColumnIdx = datatable.api().column('payment_comment:name').index('visible');

          var thead = theads.get(commentColumnIdx);

          thead.classList.add('text-right');

          var resetLink = $('<a href="#" class="js-datatable-reset-filters">сбросить все фильтры</a>')
                .appendTo(thead)
                .on('click', function (e) {
                  e.preventDefault();
                  filterRow.find('input, select').val('');
                  inputSearch.val('');
                  datatable.api().search('').columns().search('').draw();
                });
        }

      },

      infoCallback: function(settings, start, end, max, total, pre) {
        visibleRowsInfo.text(total + " из " + max);
        //return start +" to "+ end;
      },

      drawCallback: function(settings) {
        var api = this.api();
        api.rows( {selected: true, search: 'removed'} ).deselect();
      }
    });

    /**
     * Add  input filters
     */
    $.fn.dataTable.ext.search.push(
      function(settings, searchData, index, rowData, counter) {
        var minDiscount = parseInt( $('#minDiscount').val());
        var minPaid = parseInt( $('#minPaid').val());
        var minDebt = parseInt( $('#minDebt').val());

        var discountColumnIdx = courseDatatable.column('discount:name').index();
        var paidColumnIdx = courseDatatable.column('paid:name').index();
        var remainColumnIdx = courseDatatable.column('remain:name').index();

        var discount = parseInt( searchData[discountColumnIdx] ) || 0;
        var paid = parseInt( searchData[paidColumnIdx] ) || 0;
        var debt = parseInt( searchData[remainColumnIdx] ) || 0;

        if (!isNaN(minDiscount) && minDiscount > discount) {
          return false;
        }

        if (!isNaN(minPaid) && minPaid > paid) {
          return false;
        }

        if (!isNaN(minDebt) && minDebt > debt) {
          return false;
        }

        return true;
      }
    );

    initButtons();
    initInfo();
    initMailEditor();
    initSendingMailConfirmation();

    /**
     * Functions
     */

    function initButtons() {
      initSelectionButton();
      initExportButton();
      initDeleteButton();
      initSearch();
    }

    function initSearch() {
      inputSearch.on('keyup click', function () {
        courseDatatable.search(inputSearch.val()).draw();
      });
    }

    function initSelectionButton() {
      var selectButton = $('.js-button-select-all');
      var deselectButton = $('.js-button-deselect-all');

      var buttonsWidth = deselectButton.width();
      deselectButton.width(buttonsWidth);
      selectButton.width(buttonsWidth);

      deselectButton.hide();

      selectButton.click(function(event) {
        courseDatatable.buttons('selectAll:name').trigger();
        selectButton.hide();
        deselectButton.show();
      });

      deselectButton.click(function(event) {
        courseDatatable.buttons('selectNone:name').trigger();
        deselectButton.hide();
        selectButton.show();
      });
    }

    function initExportButton() {
      var exportButton = $('.js-button-export-excel');
      exportButton.click(function() {
        courseDatatable.buttons('excel:name').trigger();
      });
    }

    function initDeleteButton() {
      var deleteButton = $('.js-button-delete-deals');

      initConfirmDeletionButton();
      deleteButton.click(function() {
        var selectedRows = courseDatatable.rows({ selected: true });
        var count = selectedRows.count();

        if (count < 1) {
          alert('Не выбран ни один заказ');
          return;
        }

        $('.js-deals__delete-amount').text(count);
        $('.js-deals__delete-confirmation').modal();
      });

      function initConfirmDeletionButton() {
        var deleteConfirmationButton = $('.js-deals__delete-confirmation-button');
        deleteConfirmationButton.click(function() {
          var selectedRows = courseDatatable.rows({ selected: true });
          var selectedData = selectedRows.data().toArray();
          var selectedDealIds = selectedData.map(function(deal) {
            return deal.deal_id;
          });
          var timerInMs = 2000;

          $.ajax({
            type: 'POST',
            url: '/json/crm_handler/',
            data: {
              method: "DeleteDeals",
              "deal_ids": selectedDealIds,
            }
          }).done(function(response) {
            swal({
              type: response.swal.type,
              title: response.swal.title,
              showConfirmButton: false,
              timer: timerInMs,
              customClass: 'content-header-center'
            }).then(function() {
              if ((typeof response.swal !== 'undefined') && (response.swal.type == 'success')) {
                document.location.reload();
              }
            });
          }).fail(function(data) {
            swal({
              type: 'error',
              title: 'Ошибка подключения',
              showConfirmButton: false,
              timer: timerInMs,
              customClass: 'content-header-center'
            });
          });

        });
      }
    }

    function initInfo() {
      courseDatatable.on('select deselect', function ( e, dt, type, indexes ) {
        var selectedRowsCount = dt.rows({selected: true}).count();
        selectedRowsInfo.text(selectedRowsCount);
      });
    }

    function initMailEditor() {
      $('#template-editor').summernote({
        height: 200,
        onCreateLink : function(originalLink) {
          return originalLink; // return original link
        }
      });
    }

    function initSendingMailConfirmation() {
        var $confirmSendingButton = $('.js-deals__sending-mails-confirmation-button');
        var $mailForm = $('.js-deals__sending-mail-form');

        $confirmSendingButton.click(function() {
          $mailForm.submit();
        });
    }

    function getBooleanColumnSettings(columnName) {
      return {
        "data": columnName,
        "width": "62px",
        "className": "text-center",
        "render": renderBoolColumn,
      }
    }

    function getAmountColumnSettings(columnName) {
      return {
        "data": columnName,
        "width": "77px",
        "className": "number",
        "render": renderAmountColumn,
      }
    }

    function getContactsColumnSettings() {
      if (isSmallScreen()) {
        return {
          "data": "client.name",
          "visible": false,
          "searchable": false,
        };
      }

      return {
        "data": "client.name",
        "render": renderContactsColumn,
        "searchable": false,
      };
    }

    function isNotEmpty(data) {
       return typeof data != "undefined" && data != null && data != "null" && data.trim();
    }

    function isSmallScreen() {
      return window.screen.width < 1680;
    }

  };

  return App;
})(App || {});
